import React, { useEffect, useRef, useState } from "react";
import { Route, Redirect } from "react-router-dom";
//import Header from '../../components/header/header';
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/login";
import Header from "../../components/headerNew/header";
import Navbar from "./shared/navBarQuickbuy";
import NavbarSipHouse from "./shared/navBarSipHouse";
import Footer from "./shared/footer";
import Popup from "reactjs-popup";
import "./sessionExpiryPopup.css";
import globalVariable from "../globalVariable";
import { removeCookie } from "../../redux/actions/removeCookies";
import { fetchWithWait } from "../../helper/methods";
import { useHistory } from "react-router-dom";
import MaterialAppBar from "../../components/common/MaterialAppBar";
import { useQueryClient } from "react-query";

const PublicRoute = ({
  component: Component,
  restricted,
  sipHouse = false,
  ...rest
}) => {
  const navbarViewMoreFundsRef = useRef(null);
  let dispatch = useDispatch();
  const history = useHistory();
  const queryClient = useQueryClient();

  const singleTimeRef = useRef(false);
  const [showPopup, setshowPopup] = useState(false);

  let showQuickInvest = false;
  let path = rest?.path || "";

  if (path === "/qbconfirmation") {
    showQuickInvest = true;
  }

  const logoutClick = () => {
    queryClient.removeQueries({ queryKey: "foliodet" });
    dispatch(logout());
  };

  useEffect(() => {
    // Subscribe to the 'httpError' event
    console.log("rest.location.pathname", rest.location.pathname);
    // if (rest.location?.pathname != "/onboarding/personal") {
    const onHttpError = (status) => {
      if (status === "failed" && !singleTimeRef.current) {
        singleTimeRef.current = true;
        setshowPopup(true);
        localStorage.setItem("sessionExpired", true);
        localStorage.setItem("triggered401", true);
      }
    };

    let events = globalVariable.getPropertyByName("events");
    events.subscribe("httpError", onHttpError);

    // }

    console.log("mounting PublicRoute");
    return () => {
      console.log("unmounting PublicRoute");
      // Clean up the subscription when the component unmounts
      events.unsubscribe("httpError", onHttpError);
    };
  }, []);

  const popupClose = (e) => {
    fetchWithWait({ dispatch, action: removeCookie() })
      .then((res) => {
        // setshowPopup(false);
        localStorage.removeItem("sessionExpired");
        localStorage.removeItem("triggered401");
        // window.location.href = '/mutualfund/login';
        history.push("/login");
      })
      .catch((err) => {
        console.log("err in removeCookie: ", err);
        // setshowPopup(false);
        localStorage.removeItem("sessionExpired");
        localStorage.removeItem("triggered401");
        // window.location.href = '/mutualfund/login';
        history.push("/login");
      });
  };

  let getItem = localStorage.getItem("pageUrl");
  if (getItem == "unclaimed") {
    dispatch(logout());
  }

  return (
    // restricted = false meaning public route
    // restricted = true meaning restricted route
    <React.Fragment>
      {sipHouse === true ? (
        <MaterialAppBar logout={logoutClick} />
      ) : (
        // <NavbarSipHouse logout={logoutClick} showQuickInvest={false} navbarViewMoreFundsRef={navbarViewMoreFundsRef} />
        <Navbar
          logout={logoutClick}
          showQuickInvest={showQuickInvest}
          navbarViewMoreFundsRef={navbarViewMoreFundsRef}
        />
      )}

      {showPopup ? (
        <>
          <Popup
            open={showPopup}
            onClose={popupClose}
            className="sessionExpiredPP"
            modal
          >
            <div className="popup-contents">
              <h2 className="primary-blue-text">Session Expired</h2>
              <p>Your session has been expired!! Kindly login again.</p>
              <button className="primary-blue-button" onClick={popupClose}>
                Login
              </button>
            </div>
          </Popup>
        </>
      ) : (
        <Route
          {...rest}
          render={
            (props) =>
              restricted ? (
                <Redirect to="/portfolio" />
              ) : (
                // <div style={{ minHeight: "500px" }}> commented to remove the scroll bar
                <Component
                  {...props}
                  navbarViewMoreFundsRef={navbarViewMoreFundsRef}
                />
              )
            // </div>
          }
        />
      )}

      <Footer />
    </React.Fragment>
  );
};

export default PublicRoute;
